import { render, staticRenderFns } from "./introduction-conf.vue?vue&type=template&id=abede922&scoped=true&"
import script from "./introduction-conf.vue?vue&type=script&lang=js&"
export * from "./introduction-conf.vue?vue&type=script&lang=js&"
import style0 from "./introduction-conf.vue?vue&type=style&index=0&id=abede922&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abede922",
  null
  
)

export default component.exports